export default __webpack_public_path__ + "static/media/e28589f93c0fe0e8d5e6c2903ddc5f051579788851688.9fbc79f1.webp";